import React, {
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "styles/public.css";
import { IoClose } from "react-icons/io5";

Modal.setAppElement("#root");

const PHONE_REGEX = /^\+998\d{9}$/;
const API_URL =
  "https://algoritm-api-edu.uz/api/public/MainPageUi/ApplyApplication";

const ApplyForm = forwardRef((props, ref) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    details: "",
  });

  useImperativeHandle(ref, () => ({
    openModal: () => setModalOpen(true),
  }));

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async () => {
    if (
      !form.firstName.trim() ||
      !form.lastName.trim() ||
      !form.phoneNumber.trim()
    ) {
      toast.warning("Iltimos, barcha majburiy maydonlarni to‘ldiring!");
      return;
    }

    if (!PHONE_REGEX.test(form.phoneNumber)) {
      toast.warning("Telefon raqam +998XXXXXXXXX formatida bo‘lishi kerak!");
      return;
    }

    if (!form.details.trim()) {
      toast.warning("Izoh qoldiring!");
      return;
    }

    try {
      setLoading(true);
      await axios.post(API_URL, form, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Arizangiz muvaffaqiyatli yuborildi!");
      setForm({ firstName: "", lastName: "", phoneNumber: "", details: "" });
      closeModal();
    } catch (error) {
      console.error("Ariza yuborishda xatolik:", error);
      toast.error("Xatolik yuz berdi. Qayta urinib ko‘ring.");
    } finally {
      setLoading(false);
    }
  }, [form, closeModal]);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" && !e.shiftKey && modalOpen) {
        e.preventDefault();
        handleSubmit();
      }
    },
    [handleSubmit, modalOpen]
  );

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        pauseOnFocusLoss
        draggable
        theme="light"
        style={{ zIndex: 999999 }}
      />

      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        className="apply-popup-content"
        overlayClassName="apply-popup-overlay"
        closeTimeoutMS={300}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        style={{
          overlay: { zIndex: 99999 },
          content: { zIndex: 99999 },
        }}
      >
        <div className="popup-header">
          <h2 className="popup-title">Ariza topshiring</h2>
          <button
            className="popup-close-btn"
            onClick={closeModal}
            aria-label="Yopish"
          >
            <IoClose size={28} />
          </button>
        </div>

        <div className="popup-body">
          <input
            type="text"
            name="firstName"
            placeholder="Ismingiz"
            className="apply-input"
            value={form.firstName}
            onChange={handleChange}
            disabled={loading}
            autoComplete="given-name"
          />
          <input
            type="text"
            name="lastName"
            placeholder="Familyangiz"
            className="apply-input"
            value={form.lastName}
            onChange={handleChange}
            disabled={loading}
            autoComplete="family-name"
          />
          <input
            type="tel"
            name="phoneNumber"
            placeholder="+998901234567"
            className="apply-input"
            value={form.phoneNumber}
            onChange={handleChange}
            disabled={loading}
            maxLength="13"
          />
          <textarea
            name="details"
            placeholder="Qaysi kursga qiziqdingiz? Yoki qo‘shimcha savollaringiz..."
            className="apply-textarea"
            rows="4"
            value={form.details}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />

          <div className="popup-actions">
            <button
              className="submit-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Yuborilmoqda..." : "Yuborish"}
            </button>
            <button
              className="cancel-btn"
              onClick={closeModal}
              disabled={loading}
            >
              Bekor qilish
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
});

ApplyForm.displayName = "ApplyForm";

export default ApplyForm;
